import React from 'react';
import { useRankAListState } from '../hooks/useRankAListState';
import { useRankAListHandlers } from '../hooks/useRankAListHandlers';
import { FileUploadStep } from './steps/FileUploadStep';
import { WebsiteColumnStep } from './steps/WebsiteColumnStep';
import { PassthroughColumnsStep } from './steps/PassthroughColumnsStep';
import { ApproachSelectionStep } from './steps/ApproachSelectionStep';
import { LabelSelectionStep } from './steps/LabelSelectionStep';
import { RunJobButton } from './steps/RunJobButton';
import { JobProgressStep } from './steps/JobProgressStep';
import { DownloadResultsStep } from './steps/DownloadResultsStep';
import { CompareResultsStep } from './steps/CompareResultsStep';

export const RankAListSteps: React.FC = () => {
  const state = useRankAListState();
  const handlers = useRankAListHandlers(state);

  const {
    step,
    columns,
    websiteColumnResults,
    passthroughColumns,
    approach,
    labelColumn,
    availableLabels,
    positiveLabels,
    negativeLabels,
    jobId,
    expandedSteps,
    setExpandedSteps,
    setPositiveLabels,
    setNegativeLabels,
    uploadedFile,
    totalRows,
  } = state;

  const {
    handleFileUpload,
    handleWebsiteColumnAnalysis,
    handlePassthroughSelection,
    handleApproachSelection,
    handleLabelColumnSelection,
    handleRunJob,
  } = handlers;

  return (
    <div className="max-w-4xl space-y-4">
      <FileUploadStep
        step={step}
        expandedSteps={expandedSteps}
        setExpandedSteps={setExpandedSteps}
        onFileUpload={handleFileUpload}
        uploadedFile={uploadedFile}
        columns={columns}
        totalRows={totalRows}
      />

      <WebsiteColumnStep
        step={step}
        expandedSteps={expandedSteps}
        setExpandedSteps={setExpandedSteps}
        columns={columns}
        websiteColumnResults={websiteColumnResults}
        onAnalyze={handleWebsiteColumnAnalysis}
      />

      <PassthroughColumnsStep
        step={step}
        expandedSteps={expandedSteps}
        setExpandedSteps={setExpandedSteps}
        columns={columns}
        passthroughColumns={passthroughColumns}
        onSelect={handlePassthroughSelection}
      />

      <ApproachSelectionStep
        step={step}
        expandedSteps={expandedSteps}
        setExpandedSteps={setExpandedSteps}
        approach={approach}
        onSelect={handleApproachSelection}
      />

      {approach === 'prediction' && (
        <LabelSelectionStep
          step={step}
          expandedSteps={expandedSteps}
          setExpandedSteps={setExpandedSteps}
          columns={columns}
          labelColumn={labelColumn}
          availableLabels={availableLabels}
          positiveLabels={positiveLabels}
          negativeLabels={negativeLabels}
          onLabelColumnChange={handleLabelColumnSelection}
          onPositiveLabelsChange={setPositiveLabels}
          onNegativeLabelsChange={setNegativeLabels}
        />
      )}

      <RunJobButton
        step={step}
        approach={approach}
        labelColumn={labelColumn}
        positiveLabels={positiveLabels}
        onRunJob={handleRunJob}
      />

      <JobProgressStep
        step={step}
        expandedSteps={expandedSteps}
        setExpandedSteps={setExpandedSteps}
        approach={approach}
        jobId={jobId}
      />

      <DownloadResultsStep
        step={step}
        expandedSteps={expandedSteps}
        setExpandedSteps={setExpandedSteps}
        approach={approach}
        jobId={jobId}
      />

      <CompareResultsStep
        step={step}
        expandedSteps={expandedSteps}
        setExpandedSteps={setExpandedSteps}
        approach={approach}
        jobId={jobId}
      />
    </div>
  );
}; 